import React from "react";
import PropTypes from "prop-types";

const CompanyBuildingIcon = ({
  width,
  height,
  color,
  strokeWidth,
  className,
  ...props
}) => (
  <svg
    width={width || 24}
    height={height || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M10 12H14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 8H14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 21V18C14 16.8962 13.1038 16 12 16C10.8962 16 10 16.8962 10 18V21"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 10H4C2.89617 10 2 10.8962 2 12V19C2 20.1038 2.89617 21 4 21H20C21.1038 21 22 20.1038 22 19V9C22 7.89617 21.1038 7 20 7H18"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 21V5C6 3.89617 6.89617 3 8 3H16C17.1038 3 18 3.89617 18 5V21"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CompanyBuildingIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

CompanyBuildingIcon.defaultProps = {
  width: undefined,
  height: undefined,
  color: "#31237D",
  strokeWidth: 2,
  className: "",
};

export default CompanyBuildingIcon;
